var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u(
        [
          _vm.isEmbedded
            ? {
                key: "card-header",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0",
                        attrs: { variant: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("back")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      ← " +
                            _vm._s(_vm.$t("global.words.back")) +
                            "\n    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "pl-5 ml-5 bold" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("financial-tools.mortgage_analyzer")) +
                          "\n    "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "card-footer",
            fn: function () {
              return [
                _c("mortgage-calculators-toolbar", {
                  attrs: {
                    "is-loading": _vm.isLoading,
                    "loading-succeeded": _vm.loadingSucceeded,
                    "show-calculate": false,
                    "show-preview": false,
                  },
                  on: {
                    "clear-selection": _vm.handleClearSelection,
                    "set-default": function ($event) {
                      return _vm.amortLink(-1)
                    },
                    "run-report": _vm.runReport,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "span",
        [
          _c("b-row", { staticClass: "ml-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("financial-tools.mortgage_analyzer_description")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.mortgage_term")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: {
                          title: _vm.$t(
                            "financial-tools.mortgage_term_description"
                          ),
                          customClass: "tooltip-left",
                        },
                        expression:
                          "{\n            title: $t('financial-tools.mortgage_term_description'),\n            customClass: 'tooltip-left'\n          }",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("years-months-section", {
                    attrs: {
                      name: "mortgageTerm",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.mortgage_term"),
                      "show-tooltip-message": true,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.mortgageTerm,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "mortgageTerm", $$v)
                      },
                      expression: "inoudata.mortgageTerm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("application-form.payment-frequency")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: {
                          title: _vm.$t(
                            "financial-tools.paymentFrequencyTermDescription"
                          ),
                          customClass: "tooltip-left",
                        },
                        expression:
                          "{\n            title: $t('financial-tools.paymentFrequencyTermDescription'),\n            customClass: 'tooltip-left'\n          }",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-0", attrs: { cols: "12", sm: "3" } },
                [
                  _c("select-section", {
                    attrs: {
                      name: "frequency",
                      options: _vm.mortgageFrequencyOptions,
                      required: true,
                      "placeholder-option": false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "frequency", $$v)
                      },
                      expression: "inoudata.frequency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.amortization_period")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: {
                          title: _vm.$t(
                            "financial-tools.amortization_period_description"
                          ),
                          customClass: "tooltip-left",
                        },
                        expression:
                          "{\n            title: $t('financial-tools.amortization_period_description'),\n            customClass: 'tooltip-left'\n          }",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("years-months-section", {
                    attrs: {
                      name: "amortizPeriodMths",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.amortization_period"),
                      "show-tooltip-message": true,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.amortizPeriodMths,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "amortizPeriodMths", $$v)
                      },
                      expression: "inoudata.amortizPeriodMths",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: {
                          title: _vm.$t(
                            "financial-tools.mortgage_amount_description"
                          ),
                          customClass: "tooltip-left",
                        },
                        expression:
                          "{\n            title: $t('financial-tools.mortgage_amount_description'),\n            customClass: 'tooltip-left'\n          }",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "totalLoanAmount",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm
                        .$t("financial-tools.mortgage_amount")
                        .toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.totalLoanAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "totalLoanAmount", $$v)
                      },
                      expression: "inoudata.totalLoanAmount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.interest_rate")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: {
                          title: _vm.$t(
                            "financial-tools.interest_rate_description"
                          ),
                          customClass: "tooltip-left",
                        },
                        expression:
                          "{\n            title: $t('financial-tools.interest_rate_description'),\n            customClass: 'tooltip-left'\n          }",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      placeholder: "0",
                      "class-name": "fe-num-field decimal-input",
                      decimals: 3,
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.interest_rate").toString(),
                      max: "100",
                      "max-length": 6,
                      "show-tooltip-message": true,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.interestRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "interestRate", $$v)
                      },
                      expression: "inoudata.interestRate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.payBal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("financial-tools.calculate_payment_balance")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.amortLink(-1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "financial-tools.calculate_amortization_schedule"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row"),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.mortgage_payment")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formatMoneyValueLong(
                          _vm.roundReg(_vm.inoudata.PandI)
                        )
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("financial-tools.revisedAmortizationPeriod")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "5" },
                },
                [
                  _c("years-months-section", {
                    attrs: {
                      name: "mortgageTerm",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      disabled: true,
                      label: _vm.$t(
                        "financial-tools.revisedAmortizationPeriod"
                      ),
                      "show-tooltip-message": true,
                    },
                    model: {
                      value: _vm.inoudata.revamortizPeriodMths,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "revamortizPeriodMths", $$v)
                      },
                      expression: "inoudata.revamortizPeriodMths",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "pt-2 bold", attrs: { cols: "12", sm: "3" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("financial-tools.mortgage_balance_remaining")
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            _vm._l(Object.keys(_vm.inoudata.mainyr), function (ayr, ind) {
              return _c(
                "b-col",
                {
                  key: "yr" + ind,
                  staticClass: "pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        ayr + " " + _vm.$tc("global.words.year", parseInt(ayr))
                      ) +
                      "\n      "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            _vm._l(Object.values(_vm.inoudata.mainyr), function (ayr, ind) {
              return _c(
                "b-col",
                {
                  key: "val" + ind,
                  staticClass: "pt-2",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formatMoneyValueLong(_vm.roundReg(ayr))) +
                      "\n      "
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("b-row"),
        ],
        1
      ),
      _vm._v(" "),
      _c("mortgage-amschedule", {
        attrs: { inoudata: _vm.inoudata },
        on: { generated: _vm.generatedAmSchedule },
      }),
      _vm._v(" "),
      _c("b-row", { staticClass: "mt-4 ml-1" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }